import classNames from "classnames";
import { ConditionalLink } from "components/conditionalLink";
import { FileObject } from "types/Models/fileObject";

export const OtherAttachmentsItem = ({
  item,
  onDownloadFile,
  isLastIndex,
  index,
}: {
  item: FileObject;
  onDownloadFile: (uuid: string) => void;
  isLastIndex: boolean;
  index: number;
}) => {
  const showDocument =
    item.document && item.document_type && item.document_type === "UPLOAD";
  const showLinks =
    item.document_type &&
    (item.document_type === "LINK" || item.document_type === "GENERATE");
  return (
    <div
      className={classNames(
        "t-flex t-w-full t-justify-between t-text-text-60 t-border-b-subtext t-border-b t-border-t-0 t-border-l-0 t-border-r-0 t-border-solid t-border-neutral-0 t-py-5 ",
        { "t-border-b-0": isLastIndex, "t-pt-3.5": index === 0 }
      )}
    >
      <div className="t-text-subtext t-text-text-60 ">
        {(item.document_name && item.document_name) || "-"}
      </div>
      <div>
        {showDocument && (
          <span
            onClick={(e) => {
              e.stopPropagation();
              onDownloadFile(item.document?.uuid!);
            }}
            className="t-text-purple-70 t-text-body-sm t-font-medium t-no-underline hover:t-underline t-cursor-pointer t-px-2"
          >
            View document
          </span>
        )}
        {showLinks && (
          <ConditionalLink
            onClick={(e) => {
              e.stopPropagation();
            }}
            to={item.url || ""}
            target="_blank"
          >
            <span className="t-text-purple-70 t-text-body-sm t-font-medium t-no-underline hover:t-underline t-px-2">
              Visit Link
            </span>
          </ConditionalLink>
        )}
      </div>
    </div>
  );
};
